export default function () {
    const supplyChainData = {
        recycle: [
            {
                company: {
                    companyId: 1,
                    logoUrl: require('@/assets/png/chainCompany/recycle/company-logo-1.png'),
                    name: 'HORNG EN CO., LTD.',
                },
                contact: {
                    name: 'Miss Hong',
                    phone: '04-8966172#85',
                    email: 'ann_hung@horngen.com',
                },
                recycle: {
                    types: ['PET', 'PP', 'PE', 'PA', 'PS'],
                    allowedRange: 'Taiwan',
                },
            },
            {
                company: {
                    companyId: 2,
                    logoUrl: require('@/assets/png/chainCompany/recycle/company-logo-2.png'),
                    name: 'UNITED ONE RECYCLE CO., INC.',
                },
                contact: {
                    name: 'Manager Chen',
                    phone: '03-4725666',
                    email: 'unione.recycle@gmail.com',
                },
                recycle: {
                    types: ['EPS'],
                    allowedRange:
                        'Taipei City, New Taipei City, Taoyuan City, Hsinchu City, Hsinchu County',
                },
            },
        ],
        manufacture: [
            {
                company: {
                    companyId: 1,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-1.jpeg'),
                    name: 'SUPER TEXTILE CORPORATION',
                },
                contact: {
                    name: 'Miss Huang',
                    phone: '02-25117157',
                    email: 'sophie@supertextile.tw',
                },
                recycle: {
                    types: ['PET'],
                },
                product: {
                    types: [''],
                },
            },
            {
                company: {
                    companyId: 2,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-2.png'),
                    name: 'Global Green Material Co., Ltd.',
                },
                contact: {
                    name: 'Manager Zhang',
                    phone: '04-8932525＃240',
                    email: 'raymond@globalgreenmaterial.com',
                },
                recycle: {
                    types: ['PE', 'PS'],
                },
                product: {
                    types: ['fragments'],
                },
            },
            {
                company: {
                    companyId: 3,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-3.png'),
                    name: 'Boretech Resource Recovery Technology CO., LTD.',
                },
                contact: {
                    name: 'Miss Liu',
                    phone: '06-6233306＃219',
                    email: 'peggy.liu@bo-re-tech.com',
                },
                recycle: {
                    types: ['PET', 'PP'],
                },
                product: {
                    types: ['pellet', 'fragments'],
                },
            },
            {
                company: {
                    companyId: 4,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-4.png'),
                    name: 'HORNG EN CO., LTD.',
                },
                contact: {
                    name: 'Miss Hong',
                    phone: '04-8966172#85',
                    email: 'ann_hung@horngen.com',
                },
                recycle: {
                    types: ['PET', 'PP', 'PE', 'PA', 'PS, ABS'],
                },
                product: {
                    types: ['pellet'],
                },
            },
            {
                company: {
                    companyId: 5,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-5.png'),
                    name: 'UNITED ONE RECYCLE CO., INC.',
                },
                contact: {
                    name: 'Manager Chen',
                    phone: '03-4725666',
                    email: 'unione.recycle@gmail.com',
                },
                recycle: {
                    types: ['PP', 'PS, PO'],
                },
                product: {
                    types: ['pellet'],
                },
            },
            {
                company: {
                    companyId: 6,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-6.png'),
                    name: 'Taijei Precision CO., Ltd.',
                },
                contact: {
                    name: 'Mr. Yang',
                    phone: '0953-681272',
                    email: 'leon.hi@msa.hinet.net',
                },
                recycle: {
                    types: ['PET', 'PS'],
                },
                product: {
                    types: ['wood plastic composite'],
                },
            },
            {
                company: {
                    companyId: 7,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-7.png'),
                    name: 'Poseidon Global Industries Co., Ltd.',
                },
                contact: {
                    name: 'Jack Lam',
                    phone: '03-3859800',
                    email: 'j.lam@psdindustry.com',
                },
                recycle: {
                    types: ['PP', 'PE', 'PS', 'PA', 'others'],
                },
                product: {
                    types: ['others'],
                },
            },
        ],
        brand: [
            {
                company: {
                    companyId: 1,
                    logoUrl: require('@/assets/png/chainCompany/brand/company-logo-1.png'),
                    name: 'GREENVINES BIOTECH CO., LTD.',
                },
                contact: {
                    name: 'Miss Yu',
                    phone: '02-27076788 #115',
                    email: 'gina.yu@greenvines.com.tw',
                },
                product: {
                    types: ['Cleaning Products for Skin and Hair'],
                },
            },
        ],
    }
    return { supplyChainData }
}
